import React, { useEffect } from 'react'

export const useAssetVizImageHandler = (
  textureLoading: boolean,
  assetVizDom: React.RefObject<HTMLDivElement>,
  setAssetImage?:
    | React.Dispatch<React.SetStateAction<string | null>>
    | undefined
) => {
  useEffect(() => {
    if (!textureLoading && setAssetImage) {
      const timer = setTimeout(() => {
        const firstCanvasChild = assetVizDom.current?.querySelector('canvas')
        const canvasImage = firstCanvasChild?.toDataURL()
        setAssetImage(canvasImage ?? '')
      }, 50)
      return () => clearTimeout(timer)
    }
  }, [textureLoading, assetVizDom, setAssetImage])
}
